exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flags .q-item-avatar{width:24px!important;height:24px!important}.flags .q-item-side{height:24px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a770dc9a","scoped":false,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/LocaleDropdown.vue
// module id = kp/i
// module chunks = 44